import {
    MDBAlert,
    MDBAutocomplete,
    MDBBtn, MDBBtnGroup, MDBCardBody,
    MDBCardText,
    MDBCardTitle,
    MDBCheckbox,
    MDBDatatable, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBIcon,
    MDBInput,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBSelect,
    MDBSpinner,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
    MDBTextArea,
    MDBTooltip
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from "react";
import { useForm } from 'react-hook-form';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Tooltip } from 'react-tooltip';
import { deleteMediaFileInfo, deleteMultiMediaFileInfo, downloadMultiGreeting, getAllMediaInfo, getGreeting, getMisc, updateDefaultMOH } from '../../apiclients/streamsapi_bridge';
import Body from "../../components/body/BodyPage";
import { getAudioFile } from '../../components/mediaplayers/AudioPlayer';
import MainLinks from "../../components/navlinks/MainLinks";
import SaveChanges from '../../components/topviews/saveCancel';
import RecordMedia from '../MediaLibrary/RecordMedia';
import UploadMedia from '../MediaLibrary/UploadMedia';
import PopupLoader from '../popups/PopupLoader';
import { useAdminContext } from '../../components/adminstore/Admin-Context';
import TexttoSpeech from '../MediaLibrary/TexttoSpeech';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../components/CustomSearchUtil/CustomSearch';
import TabIDConstant from '../../apiclients/TabIDConstant';
import TTSGenerationPopup from '../../components/TTSGenerationPopup';
const defaultData = ['One', 'Two', 'Three'];
function MediaLanding(props) {
    const [data, setData] = useState(defaultData);
    const [allChecked, setallChecked] = useState(false);

    const onSearch = (value) =>
        setData(defaultData.filter((item) => item.toLowerCase().startsWith(value.toLowerCase())));

    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [basicActive, setBasicActive] = useState('tab1');
    const [mediaInfo, setmediaInfo] = useState({});

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    const [holdMusicActive, setHoldMusicActive] = useState('tab1');

    const handleHoldMusicClick = (value) => {
        if (value === holdMusicActive) {
            return;
        }

        setHoldMusicActive(value);
    };

    const [uploadMediaFlag, setUploadMediaFlag] = useState(false);
    const uploadMediaToggle = () => setUploadMediaFlag(!uploadMediaFlag);

    const [recordMediaFlag, setRecordMediaFlag] = useState(false);
    const RecordMediaToggle = () => setRecordMediaFlag(!recordMediaFlag);

    const [PlayList, setPlayList] = useState(false);
    const AddPlayList = () => setPlayList(!PlayList);
    const [isloading, setIsloading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [DeleteMusicUpload, setDeleteMusicUpload] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    const [showTTSGeneration, setShowTTSGeneration] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [isLoaderloading, setIsLoaderloading] = useState(false);
    const [showDownloadProgress, setShowDownloadProgress] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);
    const [downloadingFileName, setDownloadingFileName] = useState('');
    const [interErrorMessage, setinterErrorMessage] = useState("");
    // const [mediaList, setmediaList] = useState([]);
    const DeleteMusicUploadToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDeleteMusicUpload(!DeleteMusicUpload)
    };


    useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef)
    const [PlayMusic, setPlayMusic] = useState(false);
    const [blobURL, setBlobURL] = useState(null);
    const [blobFileName, setBlobFileName] = useState('');
    const [greetingQueue, setGreetingQueue] = useState([]);
    const [currentGreeting, setCurrentGreeting] = useState(null);
    const [blobName, setBlobName] = useState('');
    const audioRef = useRef(null);
    async function PlayMusicToggle(e, fileInfo) {
        e?.preventDefault();
        e?.stopPropagation();
        if (blobURL) {
            //revkoing
            URL.revokeObjectURL(blobURL);
        }
        setBlobURL(null);
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
        // Fetching the  file 
        if (!PlayMusic && fileInfo.length > 0) {
            setGreetingQueue(fileInfo); // Add greetings to the queue
            setPlayMusic(true); // Open modal
            await playNextGreeting(fileInfo[0]);
        }
        setPlayMusic(!PlayMusic)
    }

    const playNextGreeting = async (nextGreeting) => {
        if (!nextGreeting) return;

        try {
            const { greeting_type, greeting_id, filename, name } = nextGreeting;

            setBlobName(name);

            // Revoke existing blob URL
            if (blobURL) URL.revokeObjectURL(blobURL);
            setBlobURL(null);

            // Reset audio
            audioRef.current?.pause();
            if (audioRef.current) audioRef.current.currentTime = 0;

            // Start loader
            setShowTTSGeneration(true);
            setIsGenerating(true);

            // API CALL
            const apiResponse = await getAudioFileInfo(
                undefined,
                greeting_type,
                greeting_id,
                filename
            );

            if (!apiResponse || apiResponse.status !== 200) {
                setShowTTSGeneration(false);
                setIsGenerating(false);
                setInternalError(true);
                return;
            }

            // ✅ Stream approach with proper error handling
            const reader = apiResponse.body.getReader();
            const chunks = [];

            // Read all chunks first
            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                chunks.push(value);
            }

            // Stop loader after download complete
            setShowTTSGeneration(false);
            setIsGenerating(false);

            // Create blob from chunks
            const blob = new Blob(chunks, { type: 'audio/mpeg' });
            const objectURL = URL.createObjectURL(blob);

            // Set audio source
            setBlobURL(objectURL);
            setBlobFileName(filename);
            setCurrentGreeting(nextGreeting);

        } catch (error) {
            console.error("Unable to load the greeting audio:", error);
            setShowTTSGeneration(false);
            setIsGenerating(false);
            setInternalError(true);
        }
    };


    async function getAudioFileInfo(uniqueId, greetingType, greetingId = 0, fileName = '') {
        try {
            let reqBodyInfo = {
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                greeting_type: greetingType,
                greeting_id: greetingId,
                filename: fileName,
                id: uniqueId
            }
            let apiResponse = await getGreeting(reqBodyInfo);
            return apiResponse;
        } catch (error) {
            console.log(`Unable to load the audio file : ${error}`);
        }
        return '';
    }


    const handleAudioEnd = () => {
        const currentIndex = greetingQueue.findIndex((g) => g === currentGreeting);
        const nextIndex = currentIndex + 1;

        if (nextIndex < greetingQueue.length) {
            playNextGreeting(greetingQueue[nextIndex]);
        } else {
            setPlayMusic(false); // Close modal if all greetings are played
        }
    };




    // async function downloadMediaFile(event, fileInfo) {
    //     try {
    //         event.stopPropagation();
    //         event.preventDefault();
    //         setIsloading(true);
    //         let blobUrl = await getAudioFile(undefined, fileInfo.greeting_type, fileInfo.greeting_id, fileInfo.filename);
    //         setIsloading(false);

    //         if (blobURL != '') {
    //             const a = document.createElement('a');
    //             a.href = blobUrl;
    //             // a.download =fileInfo.filename;
    //             a.download = `${fileInfo.name}.${fileInfo.filename.split('.').pop()}`;
    //             a.style.display = 'none';
    //             document.body.appendChild(a);
    //             a.click();
    //             document.body.removeChild(a);
    //         } else {
    //             setInternalError(true);
    //         }
    //     } catch (e) {
    //         console.log(`Unable to process the request:${e}`);
    //         setInternalError(true);
    //         setIsloading(false);

    //     }
    // }

    async function downloadMediaFile(event, fileInfo) {
        event.stopPropagation();
        event.preventDefault();

        try {
            const fileExt = fileInfo.filename.split(".").pop();
            const fileName = `${fileInfo.name}.${fileExt}`;

            // Show progress modal
            setDownloadingFileName(fileName);
            setShowDownloadProgress(true);
            setDownloadProgress(0);

            const response = await getGreeting({
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                greeting_type: fileInfo.greeting_type,
                greeting_id: fileInfo.greeting_id,
                filename: fileInfo.filename,
                id: undefined,
                isDownload: true
            });

            if (!response || response.status !== 200) {
                setShowDownloadProgress(false);
                setInternalError(true);
                setInternalErrorMessage(response?.message || 'File does not exist.');
                return;
            }



            // Get total size if available
            const contentLength = response.headers.get('Content-Length');
            const total = contentLength ? parseInt(contentLength, 10) : null;

            // --- STREAM READER WITH PROGRESS ---
            const reader = response.body.getReader();
            const chunks = [];
            let receivedLength = 0;

            // Read chunks and update progress
            while (true) {
                const { done, value } = await reader.read();

                if (done) break;

                chunks.push(value);
                receivedLength += value.length;

                // Update progress based on received data
                if (total) {
                    // If we have Content-Length, show actual progress
                    const progress = (receivedLength / total) * 100;
                    setDownloadProgress(Math.min(progress, 99)); // Cap at 99% until complete
                } else {
                    // Without Content-Length, estimate progress based on chunks
                    const estimatedProgress = Math.min(
                        90,
                        (receivedLength / 1024 / 1024) * 10 // Rough estimate: 10% per MB
                    );
                    setDownloadProgress(estimatedProgress);
                }
            }

            // Set to 100% when done
            setDownloadProgress(100);

            // Brief delay to show 100%
            await new Promise(resolve => setTimeout(resolve, 400));

            // --- FINAL FILE ASSEMBLY ---
            const finalBlob = new Blob(chunks);
            const finalUrl = URL.createObjectURL(finalBlob);

            // --- TRIGGER DOWNLOAD ---
            const a = document.createElement("a");
            a.href = finalUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();

            URL.revokeObjectURL(finalUrl);

            // Hide progress modal
            setShowDownloadProgress(false);
            setDownloadProgress(0);

        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
            setShowDownloadProgress(false);
            setDownloadProgress(0);
        }
    }


    const [defaultMohInfo, setDefaultMohInfo] = useState('');




    async function updateDefaultMOHGre(greInfo) {
        try {
            let apiResponse = await updateDefaultMOH({ siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid, moh_greeting_id: greInfo.moh_greeting_id, greeting_type: greInfo.greeting_type })
            if (apiResponse.status == 200) {
                let resbody = await apiResponse.json();
                if (resbody.status == 'failed') {
                    localStorage.setItem("f_message", resbody.message);
                } else {
                    localStorage.setItem("s_message", resbody.message);
                }
            } else if (apiResponse.status === 500) {
                setInternalError(true);
            }
            window.location.href = "/medialanding";

        } catch (error) {
            console.log(`Unable to process the request :${error}`);
            window.location.href = "/medialanding";
        }
    }


    const [failedErrorMessage, setFailedErrorMessage] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [fileInfo, setFileInfo] = useState({});
    const [DeleteMusic, setDeleteMusic] = useState(false);
    const { setEdited } = useAdminContext();
    const [multiDelete, setmultiDelete] = useState(false);
    async function DeleteMusicToggle(event, reqFileInfo) {
        event.preventDefault();
        event.stopPropagation();
        setDeleteMusic(!DeleteMusic)
        setFileInfo(reqFileInfo);
        setBlobName(reqFileInfo?.name ?? fileInfo?.name)
        setBlobFileName(reqFileInfo?.filename ?? fileInfo?.filename);

        // const fileList = reqFileInfo?.length ? reqFileInfo : fileInfo?.length ? fileInfo : [];
        // const filenames = fileList.map(fileinfo => fileinfo.filename).join(", ");
        // setBlobFileName(filenames);
    };


    async function deleteMediaFile(event) {
        try {
            event.preventDefault();
            event.stopPropagation();
            let apiResponse = null;
            setIsLoaderloading(true);

            if (multiDelete) {
                setmultiDelete(false);
                const multiGreeting = mediaActionList.map((mediaObj) => ({ greeting_id: mediaObj.greeting_id, greeting_type: mediaObj.greeting_type, filename: mediaObj.filename, name: mediaObj.name }));
                let update = {
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                    greetings_info: multiGreeting
                }
                console.log("delete greetings :::::::::::::: " + JSON.stringify(update));
                apiResponse = await deleteMultiMediaFileInfo(update);
            } else {
                apiResponse = await deleteMediaFileInfo({
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                    greeting_type: fileInfo.greeting_type,
                    greeting_id: fileInfo.greeting_id
                    // greeting_type: fileInfo.map(fileinfo => fileinfo.greeting_type),
                    // greeting_id: fileInfo.map(fileinfo => fileinfo.greeting_id)
                });
            }
            setTimeout(() => { setIsLoaderloading(false) }, 1000);

            let resbody = await apiResponse.json();
            if (apiResponse.status === 200) {
                const hasSuccess = resbody?.success_greetings?.length > 0;
                const hasInvalid = resbody?.invalid_greetings?.length > 0;
                const hasInUse = resbody?.in_use_greetings?.length > 0;
                const hasFailed = resbody?.failed_greetings?.length > 0;
                const hasFailure = hasInvalid || hasInUse || hasFailed;

                const failureParts = [];
                if (hasInUse || hasInvalid) {
                    const inused = (resbody?.in_use_greetings ?? []).map(g => g.filename).join(", ");
                    const invalid = (resbody?.invalid_greetings ?? []).map(g => g.filename).join(", ");
                    const names = [inused, invalid].filter(Boolean).join(", ");
                    failureParts.push(`Greeting(s) ${names} cannot be removed because they are either in use or invalid.`);
                }
                if (hasFailed) {
                    const failedNames = (resbody?.failed_greetings ?? []).map(g => g.filename).join(", ");
                    failureParts.push(`Greeting(s) ${failedNames} failed to remove.`);
                }

                const successPart = hasSuccess
                    ? `Greeting(s) ${(resbody?.success_greetings ?? []).map(g => g.filename).join(", ")} successfully removed.`
                    : "";

                if (hasSuccess && hasFailure) {
                    localStorage.setItem("m_message", [successPart, ...failureParts].join(" "));
                } else if (hasFailure) {
                    localStorage.setItem("f_message", failureParts.join(" "));
                } else if (hasSuccess) {
                    localStorage.setItem("s_message", successPart);
                } else {
                    resbody?.message ? resbody?.status === 'success' ? localStorage.setItem("s_message", resbody?.message) : localStorage.setItem("f_message", resbody?.message) : setInternalError(true);
                }
            } else {
                //setInternalError(true);
                localStorage.setItem("f_message", resbody.message);
            }

        } catch (error) {
            console.log(`Unable to process the request:${error}`);
            setInternalError(true);
        }
        DeleteMusicToggle(event);
        window.location.href = "/medialanding";

    }


    const [AddToPlayList, setAddToPlayList] = useState(false);
    const AddToPlatListToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setAddToPlayList(!AddToPlayList)
    };

    const [EditMedia, setEditMedia] = useState(false);
    const EditMediaToggle = () => setEditMedia(!EditMedia);

    const [EditMediaupload, setEditMediaupload] = useState(false);
    const EditMediauploadToggle = () => setEditMediaupload(!EditMediaupload);

    const [recorder, setRecorder] = useState(false);
    const [disableMulti, setdisableMulti] = useState(true);

    const navigate = useNavigate();

    console.log(uploadMediaFlag);
    const [medialist, setMediaList] = useState([]);
    const [mediaListSearch, setmediaListSearch] = useState([]);
    const [searchValue, setsearchValue] = useState("");
    const [defaultmohlist, setDefaultmohlist] = useState([]);
    const [internalError, setInternalError] = useState(false);
    const [internalErrorMessage, setInternalErrorMessage] = useState(false);
    const [defaultFieldValue, setDefaultFiedlValue] = useState({});
    const [selectedMedia, setselectedMedia] = useState([]);
    const [mediaActionList, setmediaActionList] = useState([]);
    const { register, handleSubmit, setValue, getValues, formState: { errors, isDirty }, reset, watch } = useForm({
        defaultValues: {
            //moh_greeting_id: -1,
            refId: -1
        }
    });

    useEffect(() => {
        setEdited(isDirty);
    }, [isDirty]);

    useEffect(() => {
        if (Object.keys(defaultFieldValue).length > 0) {
            reset(defaultFieldValue);
        }

    }, [defaultFieldValue]);
    function closeSave(e) {
        reset();
    }

    async function fetchMediaDetails() {
        try {
            let apiResponse = await getAllMediaInfo(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                TabIDConstant.MEDIA_LIB_LINK
            );
            const rawData = await apiResponse.json();
            if (apiResponse.status === 200) {

                setMediaList(rawData?.greetings ?? []);
                setmediaListSearch(rawData?.greetings ?? []);
                setDefaultFiedlValue({
                    //moh_greeting_id: rawData.default_moh?.moh_greeting_id ?? -1,
                    refId: rawData.default_moh?.refId ?? -1
                });
                setDefaultMohInfo(rawData.default_moh ?? {});
            } else if (apiResponse.status === 500) {
                setInternalError(true);
            } else {
                navigate("/");
            }
        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        }
    }
    async function getMohDefaultGre() {
        try {
            let apiResponse = await getMisc(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                { misc: ["global_moh_greetings"] }
            );
            const tdata = await apiResponse.json();
            if (apiResponse.status === 200) {
                const greList = tdata?.misc?.moh_global_greetings ?? [];
                setDefaultmohlist(greList);
            } else if (apiResponse.status === 500) {
                setInternalError(true);
            } else {
                navigate("/");
            }
        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
        }
    }
    useEffect(() => {
        getMohDefaultGre();
        fetchMediaDetails();
        setDataLoaded(true)
    }, []);

    const handleAllChecked = (isChecked) => {
        if (isChecked) {
            setallChecked(true);
            setselectedMedia(medialist.map(media => media.greeting_id));
            setmediaActionList(medialist);
            setdisableMulti(false);

        } else {
            setallChecked(false);
            setselectedMedia([]);
            setmediaActionList([]);
            setdisableMulti(true);
        }
    }

    let processedMohList = [];
    defaultmohlist.forEach(e => processedMohList.push({ ...e, text: e.name ?? e.filename, value: e.refId }));
    let proccessdRows = [];
    medialist.map((fileInfo) => {
        //console.log(fileInfo.greeting_id,defaultMohInfo.moh_greeting_id)
        proccessdRows.push({
            checkBoxValue: (<>
                <MDBCheckbox checked={selectedMedia.includes(fileInfo.greeting_id)} onClick={(e) => handleCheckedRow(e, fileInfo)} />
            </>),
            filename: (<div className="d-flex align-items-center">{fileInfo.filename}
                {(defaultMohInfo.moh_greeting_id == fileInfo.greeting_id && defaultMohInfo.greeting_type == fileInfo.greeting_type) && (
                    <>
                        <div className="px-2 ms-2 border border-1 rounded-pill border-success">
                            <span className="small text-success">Default</span>
                        </div>
                    </>
                )}
            </div>),
            // filename: fileInfo.filename,
            entityType: fileInfo.entityType,
            type: fileInfo.uploadType,
            modified: fileInfo.modified,
            name: fileInfo.name,
            delete: (
                <>
                    <div className="d-flex align-items-center justify-content-end ms-2">
                        {fileInfo?.uploadType === "Text To Speech" && (
                            <div className="custom-hover-bg p-1 cursor-pointer editToolTip" onClick={(e) => handleMediaEdit(e, fileInfo)}>
                                <MDBIcon fas icon="pencil-alt" color="primary" className="mx-2 my-1 fs-5" />
                            </div>
                        )}
                        <div className="custom-hover-bg p-1 cursor-pointer playToolTip" onClick={(e) => PlayMusicToggle(e, [fileInfo])}>
                            <MDBIcon far icon="play-circle" color="primary" className="mx-2 my-1 fs-5" />
                        </div>

                        <div className="custom-hover-bg p-1 cursor-pointer downloadToolTip mx-2" onClick={(e) => downloadMediaFile(e, fileInfo)} >
                            <MDBIcon fas icon="download" color="primary" className="mx-2 my-1 fs-5" />
                        </div>
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => DeleteMusicToggle(e, fileInfo)}>
                            {/* <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => DeleteMusicToggle(e, [fileInfo])}> */}
                            <MDBIcon fas icon="times" color="primary" className="mx-2 my-1 fs-5" />
                        </div>
                    </div>
                </>
            )
        });
    });

    const handleManualSearch = (searchValue) => {
        const trimmedValue = searchValue.trim().toLowerCase();
        setsearchValue(searchValue);

        if (!trimmedValue) {
            setMediaList(mediaListSearch);
            return;
        }
        const fields = ['name', 'uploadType', 'modified'];
        const filtered = customSearch(mediaListSearch, trimmedValue, fields)

        // mediaListSearch.filter((row) =>
        //     fields.some((field) =>
        //         String(row[field] ?? '').toLowerCase().includes(trimmedValue)
        //     )
        // );

        setMediaList(filtered);

    };
    function handleCheckedRow(e, selectrow) {
        e.preventDefault();
        let updatedmedialList = [];
        let updateSelectMedia = [];

        if (e.target.checked) {
            updatedmedialList = [...mediaActionList, selectrow];
            updateSelectMedia = [...selectedMedia, selectrow.greeting_id]
        } else {
            updatedmedialList = mediaActionList.filter((tmdata) => tmdata.greeting_id !== selectrow.greeting_id);
            updateSelectMedia = selectedMedia.filter((tmdata) => tmdata !== selectrow.greeting_id);
        }
        const allSelected = medialist.length > 0 ? medialist.every(row => updateSelectMedia.includes(row.greeting_id)) : false;
        if (allSelected) {
            setallChecked(true);
        } else {
            setallChecked(false);
        }
        if (updatedmedialList.length > 0) {
            setdisableMulti(false);
        } else {
            setdisableMulti(true);
        }
        setmediaActionList(updatedmedialList);
        setselectedMedia(updateSelectMedia);
    }

    const SoundClip = {
        columns: [
            {
                label: (<>
                    <MDBCheckbox checked={allChecked} onChange={(e) => handleAllChecked(e.target.checked)} />
                </>), field: "checkBoxValue", sort: false
            },
            // { label: "File Name ", field: "filename" },
            { label: "Name", field: "name" },
            // { label: "Greeting Type ", field: "entityType" },
            { label: "Upload Type", field: "type" },
            { label: "Modified", field: "modified" },
            { label: "Actions", field: "delete", sort: false },
        ],
        rows: proccessdRows
    }


    const HoldMusic = {
        columns: [
            { label: "Name ", field: "username" },
            { label: "Actions", field: "delete", sort: false },
        ],
        rows: [
            { username: "Calm River" },
            { username: "Macroform - Cold Day" },
            { username: "Macroform - Robot Dity" },
            { username: "Macroform - The Simplicity" },
            { username: "Manolo Camp - Morning Coffee" },
        ].map((row) => {
            return {
                ...row,
                delete: (
                    <>
                        <div className="d-flex align-items-center justify-content-center">
                            <div onClick={AddToPlatListToggle}>
                                <MDBTooltip placement='left' tag='a' wrapperProps={{ href: '#' }} title="Add to Playlist">
                                    <MDBIcon fas className="float-end fs-4" icon="plus text-primary" />
                                </MDBTooltip>
                            </div>
                            <div onClick={PlayMusicToggle} className='ps-3'>
                                <MDBTooltip placement='left' tag='a' wrapperProps={{ href: '#' }} title="Play">
                                    <MDBIcon far className="float-end fs-4" icon="play-circle text-primary" />
                                </MDBTooltip>
                            </div>
                        </div>
                    </>
                ),
            };
        })
    }



    const HoldMusicUploades = {
        columns: [
            { label: "Name ", field: "username" },
            { label: "Actions", field: "delete", sort: false },
        ],
        rows: [
            { username: "sirslyhigh" },
            { username: "Blank Space" },
        ].map((row) => {
            return {
                ...row,
                delete: (
                    <>
                        <div className="d-flex align-items-center justify-content-end">
                            <div onClick={(e) => AddToPlatListToggle(e)} >
                                <MDBTooltip placement='left' tag='a' wrapperProps={{ href: '#' }} title="Add to Playlist">
                                    <MDBIcon fas className="ms-3 float-end fs-4" icon="plus text-primary" />
                                </MDBTooltip>
                            </div>
                            <div onClick={(e) => PlayMusicToggle(e)}>
                                <MDBTooltip placement='left' tag='a' wrapperProps={{ href: '#' }} title="Play">
                                    <MDBIcon far className="ms-3 float-end fs-4" icon="play-circle text-primary" />
                                </MDBTooltip>
                            </div>
                            <div>
                                <MDBTooltip placement='left' tag='a' wrapperProps={{ href: '#' }} title="Download Sound Clip">
                                    <MDBIcon fas className="ms-3 float-end fs-4" icon="download text-primary" />
                                </MDBTooltip>
                            </div>
                            <div onClick={(e) => DeleteMusicUploadToggle(e)}>
                                <MDBTooltip placement='left' tag='a' wrapperProps={{ href: '#' }} title="Delete Sound Clip">
                                    <MDBIcon className="ms-3 float-end fs-4" icon="close text-primary text-primary" />
                                </MDBTooltip>
                            </div>
                        </div>
                    </>
                ),
            };
        })
    }


    const Associatedresources = {
        columns: [
            { label: "Resource ", field: "username" },
            { label: "Reference", field: "reference" },
        ],
        rows: [
            {
                username: "Playlist",
                reference: (<>
                    <a href="#">Test <MDBIcon fas icon="external-link-alt" className="linkIcon ms-2" /></a>
                </>)
            },
            { username: "dialplans" }
        ],
    };


    const AssociatedresourcesUpload = {
        columns: [
            { label: "Resource ", field: "username" },
            { label: "Reference", field: "reference" },
        ],
        rows: [
            {
                username: "Playlist",
                reference: (<>
                    <a href="#">Test <MDBIcon fas icon="external-link-alt" className="linkIcon ms-2" /></a>
                </>)
            },
            { username: "dialplans" }
        ],
    };

    const handlePlayGreetings = (e) => {
        if (mediaActionList.length > 10) {
            alert("You can only play up to 10 greetings at a time.")
            return;
        }
        PlayMusicToggle(e, mediaActionList);

    }

    const handleDownloadGreetings = (e) => {
        if (mediaActionList.length > 10) {
            alert("You can only download up to 10 greetings at a time.")
            return;
        }
        handleDownloadMultiGreetings();

    }

    const handleDeleteGreetings = (e) => {
        if (mediaActionList.length > 10) {
            alert("You can only delete up to 10 greetings at a time.")
            return;
        }
        console.log("mediaActionList ::::::::: " + JSON.stringify(mediaActionList));
        DeleteMultiMusicToggle(e);

    }

    async function DeleteMultiMusicToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        setmultiDelete(true);
        setDeleteMusic(!DeleteMusic)
        const filenames = mediaActionList.map(item => item.filename).join(", ");
        const name = mediaActionList.map(item => item.name).join(", ");
        setBlobFileName(filenames);
        setBlobName(name)
    };

    async function handleDownloadMultiGreetings() {
        try {
            const multiGreeting = mediaActionList.map((mediaObj) => ({
                greeting_id: mediaObj.greeting_id,
                greeting_type: mediaObj.greeting_type,
                filename: mediaObj.filename,
                name: mediaObj.name
            }));

            let update = {
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                greetings_info: multiGreeting
            };

            // Show progress modal
            setDownloadingFileName('multiple files');
            setShowDownloadProgress(true);
            setDownloadProgress(0);

            let apiResponse = await downloadMultiGreeting(update);

            if (!apiResponse || apiResponse.status !== 200) {
                setShowDownloadProgress(false);
                setInternalError(true);
                return;
            }

            // Extract filename
            let filename = "download.zip";
            const contentDisposition = apiResponse.headers.get("Content-Disposition");
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match?.[1]) {
                    filename = match[1];
                    setDownloadingFileName(filename);
                }
            }

            // Get total size
            const contentLength = apiResponse.headers.get('Content-Length');
            const total = contentLength ? parseInt(contentLength, 10) : null;

            // STREAM READER with progress
            const reader = apiResponse.body.getReader();
            const chunks = [];
            let receivedLength = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                chunks.push(value);
                receivedLength += value.length;

                // Update progress
                if (total) {
                    const progress = (receivedLength / total) * 100;
                    setDownloadProgress(Math.min(progress, 99));
                } else {
                    const estimatedProgress = Math.min(
                        90,
                        (receivedLength / 1024 / 1024) * 5 // Slower estimate for zip files
                    );
                    setDownloadProgress(estimatedProgress);
                }
            }

            // Set to 100%
            setDownloadProgress(100);
            await new Promise(resolve => setTimeout(resolve, 400));

            // Assemble ZIP file
            const finalBlob = new Blob(chunks, { type: "application/zip" });
            const finalUrl = URL.createObjectURL(finalBlob);

            // Trigger download
            const a = document.createElement("a");
            a.href = finalUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();

            URL.revokeObjectURL(finalUrl);

            // Hide progress
            setShowDownloadProgress(false);
            setDownloadProgress(0);

        } catch (e) {
            console.log(`Unable to process the request:${e}`);
            setInternalError(true);
            setShowDownloadProgress(false);
            setDownloadProgress(0);
        }
    }



    const [addMediaFlag, setAddMediaFlag] = useState(false);
    const addMediaToggle = () => setAddMediaFlag(!addMediaFlag);

    const [HuntbasicActive, setHuntBasicActive] = useState('Hunttab1');
    const HunthandleBasicClick = (value) => {
        if (value === HuntbasicActive) {
            return;
        }
        setHuntBasicActive(value);
    };

    const handleClosePopup = () => {
        setHuntBasicActive("");
        setmediaInfo({}); // Clear mediaInfo when closing
        setinterErrorMessage("");
        addMediaToggle();

    }

    const handleMediaEdit = (e, data) => {
        e.preventDefault();
        e.stopPropagation();
        if (data?.uploadType === "Text To Speech") {
            console.log("Text To Speech Edit Media :::::::::: " + JSON.stringify(data));
            setinterErrorMessage("");
            setmediaInfo(data);
            setHuntBasicActive("Hunttab1")
            addMediaToggle();


        }

    }


    return (
        <React.Fragment>
            <>
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
                {isDownloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Downloading...
                            </MDBBtn>
                        </div>
                    </>
                )}
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={29}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header pt-3 pb-0 px-0">
                                        <div className="d-flex align-items-start justify-content-between">
                                            <div className="general-settings">
                                                {t("mediaLibrary")}
                                            </div>
                                            <div>
                                                {/* <MDBBtn className="ms-3" onClick={uploadMediaToggle}><MDBIcon fas icon="plus" size="sm" /> {t('UploadMedia')}</MDBBtn> */}
                                                {/* <MDBBtn className="ms-3" onClick={RecordMediaToggle}><MDBIcon fas icon="plus" size="sm" /> {t('RecordMedia')}</MDBBtn> */}
                                                <MDBBtn onClick={(e) => {
                                                    setHuntBasicActive("Hunttab1");
                                                    setmediaInfo({});
                                                    setinterErrorMessage("");
                                                    addMediaToggle();
                                                }}><MDBIcon fas icon="plus" size="sm" className='me-2' />Add Media</MDBBtn>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0 px-0">
                                        <div className='p-0 col-md-6 tab-w-70 mob-w-100'>
                                            <MDBCardBody className='d-flex justify-content-between align-items-center greet-select'>
                                                <div>
                                                    <MDBCardTitle className='mb-0'>Default Music On Hold</MDBCardTitle>
                                                </div>
                                                <MDBCardText>
                                                    {/* <select
                                                        className="form-control form-select selectname w-100" style={{minWidth:'250px'}}
                                                        // {...register("moh_greeting_id")}
                                                        value={watch("moh_greeting_id")}
                                                        // data={processedMohList}
                                                        search
                                                        onChange={(e) => {
                                                            if (e && e.target.value !== undefined) {
                                                                setValue("moh_greeting_id", e.target.value, { shouldDirty: true });
                                                            }
                                                        }

                                                            //}

                                                        }
                                                    >
                                                        {processedMohList && processedMohList.length > 0 && processedMohList.map((list) => (
                                                            <option value={list.moh_greeting_id}>{list.text}</option>
                                                        ))}
                                                    </select> */}


                                                    <MDBSelect
                                                        className="form-control media-select-control selectname p-0 border-0" style={{ width: '250px', maxWidth: '250px' }}
                                                        data={processedMohList}
                                                        value={watch("refId")}
                                                        search
                                                        onChange={(e) => {
                                                            if (e && e.value !== undefined) {
                                                                setValue("refId", e.value, { shouldDirty: true })
                                                                setValue("moh_greeting_id", e.moh_greeting_id);
                                                                setValue("greeting_type", e.greeting_type);
                                                            }
                                                        }}
                                                    />
                                                </MDBCardText>
                                            </MDBCardBody>
                                        </div>
                                        <MDBTabs className='mb-1'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    {t('Soundclips')}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            {/* <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    {t('holdmusic')}
                                                </MDBTabsLink>
                                            </MDBTabsItem> */}
                                            {/* <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                                                    {t('playlists')}
                                                </MDBTabsLink>
                                            </MDBTabsItem> */}
                                        </MDBTabs>
                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                {/* Tab 1 content */}
                                                <div className="soundclipsdatatable mt-0">
                                                    <div class="actionbar">
                                                        <MDBBtnGroup
                                                            aria-label="Button group with nested dropdown"
                                                            className="display-inline ms-3 btn_adjust h-inherit"
                                                        >
                                                            <MDBBtnGroup>
                                                                <MDBDropdown>
                                                                    <MDBDropdownToggle className="px-3" disabled={disableMulti}>
                                                                        <div className="text-white">
                                                                            <MDBIcon fas icon="ellipsis-v" className="me-2" />
                                                                            More
                                                                        </div>
                                                                    </MDBDropdownToggle>
                                                                    <MDBDropdownMenu>
                                                                        <MDBDropdownItem link onClick={(e) => handlePlayGreetings(e)}>Play</MDBDropdownItem>
                                                                        <MDBDropdownItem link onClick={(e) => handleDownloadGreetings(e)}>Download</MDBDropdownItem>
                                                                        <MDBDropdownItem link onClick={(e) => handleDeleteGreetings(e)}><p className="text-danger">Delete</p></MDBDropdownItem>
                                                                    </MDBDropdownMenu>
                                                                </MDBDropdown>
                                                            </MDBBtnGroup>
                                                        </MDBBtnGroup>
                                                    </div>
                                                    <div className='mb-2 mt-3 position-relative w-auto'>
                                                        <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                                                        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                                    </div>
                                                    <MDBDatatable key={searchValue} className='tablelastchild'
                                                        // onRowClick={EditMediaToggle}
                                                        sortField="File Name "
                                                        sortOrder="asc"
                                                        data={SoundClip}
                                                        fixedHeader
                                                        entries={50} />
                                                </div>
                                            </MDBTabsPane>
                                            <MDBTabsPane open={basicActive === 'tab2'}>
                                                {/* Tab 2 content */}

                                                <MDBTabs className='mb-3'>
                                                    <MDBTabsItem>
                                                        <MDBTabsLink onClick={() => handleHoldMusicClick('tab1')} active={holdMusicActive === 'tab1'}>
                                                            {t('system')}
                                                        </MDBTabsLink>
                                                    </MDBTabsItem>
                                                    <MDBTabsItem>
                                                        <MDBTabsLink onClick={() => handleHoldMusicClick('tab2')} active={holdMusicActive === 'tab2'}>
                                                            {t('uploaded')}
                                                        </MDBTabsLink>
                                                    </MDBTabsItem>

                                                </MDBTabs>

                                                <MDBTabsContent>
                                                    <MDBTabsPane open={holdMusicActive === 'tab1'}>
                                                        {/* Tab 1 content */}
                                                        <div className="holdMusicActiveDatatable">
                                                            <div class="actionbar"></div>
                                                            <MDBDatatable search data={HoldMusic} className='tablelastchild' sortField="File Name" />
                                                        </div>
                                                    </MDBTabsPane>
                                                    <MDBTabsPane open={holdMusicActive === 'tab2'}>
                                                        {/* Tab 2 content */}
                                                        <div className="holdMusicActiveDatatable">
                                                            <div class="actionbar"></div>
                                                            <MDBDatatable search className='tablelastchild'
                                                                onRowClick={EditMediauploadToggle}
                                                                data={HoldMusicUploades} sortField="Name" />
                                                        </div>
                                                    </MDBTabsPane>
                                                </MDBTabsContent>
                                            </MDBTabsPane>
                                            {/* <MDBTabsPane open={basicActive === 'tab3'}>
                                             
                                                <MDBDatatable search data={PlayListTable} onRowClick={PlayListSettingsRoute} />
                                            </MDBTabsPane> */}
                                        </MDBTabsContent>


                                    </div>
                                </div>
                            </section>
                        </>
                    }
                />

                {/* upload media popup */}
                {uploadMediaFlag && (
                    <PopupLoader
                        title={t('UploadMedia')}
                        content={<UploadMedia onClose={uploadMediaToggle} />}
                        onClose={uploadMediaToggle}
                    />
                )}


                {/* Record media popup */}
                {recordMediaFlag && (
                    <PopupLoader
                        title={t('RecordMedia')}
                        content={<RecordMedia onClose={RecordMediaToggle} />}
                        onClose={RecordMediaToggle}
                    />
                )}




                <MDBModal staticBackdrop open={addMediaFlag} onClose={() => {
                    setAddMediaFlag(false);
                    setHuntBasicActive("");
                    setinterErrorMessage("");
                    setmediaInfo({}); // Clear mediaInfo
                }} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{mediaInfo && Object.keys(mediaInfo).length > 0 ? "Edit Media" : "Add Media"}</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={() => {
                                    addMediaToggle();
                                    setinterErrorMessage("");
                                    setmediaInfo({}); // Clear mediaInfo
                                }}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <MDBTabs className='mb-3' pills>
                                    <MDBTabsItem>
                                        <MDBTabsLink onClick={() => HunthandleBasicClick('Hunttab1')} active={HuntbasicActive === 'Hunttab1'}   >
                                            Text to Speech
                                        </MDBTabsLink>
                                    </MDBTabsItem>
                                    {(!mediaInfo || Object.keys(mediaInfo).length === 0) && (<>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => HunthandleBasicClick('Hunttab2')} active={HuntbasicActive === 'Hunttab2'}   >
                                                {t("upload")}
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => HunthandleBasicClick('Hunttab3')} active={HuntbasicActive === 'Hunttab3'}   >
                                                {t("recordonMic")}
                                            </MDBTabsLink>
                                        </MDBTabsItem>
                                    </>)}
                                </MDBTabs>

                                <MDBTabsContent>
                                    <MDBTabsPane open={HuntbasicActive === 'Hunttab1'}>
                                        <TexttoSpeech
                                            onClose={handleClosePopup}
                                            isActive={HuntbasicActive === 'Hunttab1'}
                                            mediaInfo={mediaInfo}
                                            setmediaInfo={setmediaInfo}
                                            interErrorMessage={interErrorMessage}
                                            setinterErrorMessage={setinterErrorMessage}
                                        />
                                    </MDBTabsPane>
                                    {(!mediaInfo || Object.keys(mediaInfo).length === 0) && (<>
                                        <MDBTabsPane open={HuntbasicActive === 'Hunttab2'}>
                                            <UploadMedia onClose={handleClosePopup}
                                                isActive={HuntbasicActive === 'Hunttab2'}
                                            />
                                        </MDBTabsPane>
                                        <MDBTabsPane open={HuntbasicActive === 'Hunttab3'}>
                                            <RecordMedia onClose={handleClosePopup}
                                                isActive={HuntbasicActive === 'Hunttab3'}
                                            />
                                        </MDBTabsPane>
                                    </>)}
                                </MDBTabsContent>
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>










                <MDBModal tabIndex='-1' open={PlayList} setOpen={setPlayList}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{t('addplaylist')}</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={AddPlayList}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <div class="tel-numbers"><strong>{t("name")}</strong></div>
                                <input className="form-control form-outline" id='form1' type='text' placeholder="Enter playlist Name" />

                                <div className="d-flex align-items-center justify-content-between mt-3">
                                    <div class="tel-numbers"><strong>{t("Shuffle")}</strong></div>

                                    <div className="phoneselect">
                                        <label className="switch">
                                            <input className="form-control" type="checkbox" />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color='secondary' onClick={AddPlayList}>
                                    {t("close")}
                                </MDBBtn>
                                <MDBBtn>{t("save")}</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>



                <MDBModal tabIndex='-1' open={DeleteMusic} setOpen={setDeleteMusic}>
                    <>
                        <MDBModalDialog centered>
                            <MDBModalContent>
                                <MDBModalHeader>
                                    <MDBModalTitle className='header-ellipses' title={blobName}>{t('Deletesoundclip')} {blobName}</MDBModalTitle>
                                    {/* <MDBModalTitle className='filterElliipse' title={blobFileName}>{t('Deletesoundclip')} {blobFileName}</MDBModalTitle> */}
                                    <MDBBtn className='btn-close' color='none' onClick={DeleteMusicToggle}></MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody>
                                    <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
                                        <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
                                        <span>This will remove the media file and can not be undone.</span>
                                    </div>
                                </MDBModalBody>
                                <MDBModalFooter>
                                    <MDBBtn color='secondary' onClick={DeleteMusicToggle}>
                                        {t("close")}
                                    </MDBBtn>
                                    <MDBBtn color="primary" onClick={(e) => deleteMediaFile(e)}>Remove</MDBBtn>
                                </MDBModalFooter>
                            </MDBModalContent>
                        </MDBModalDialog>
                        {isLoaderloading && (
                            <>
                                <div className="loadingclass">
                                    <MDBBtn disabled>
                                        <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                        Loading...
                                    </MDBBtn>
                                </div>
                            </>
                        )}


                    </>
                </MDBModal>


                <MDBModal tabIndex='-1' open={PlayMusic} setshow={setPlayMusic}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle className="w-100" style={{ maxWidth: "325px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}  >{blobName}</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={PlayMusicToggle}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <audio className="w-100" src={blobURL} ref={audioRef} controls onEnded={handleAudioEnd} autoPlay ></audio>
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color='secondary' onClick={PlayMusicToggle}>
                                    {t("close")}
                                </MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>



                <MDBModal tabIndex='-1' open={AddToPlayList} setOpen={setAddToPlayList}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{t('Addtoplaylist')}</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={AddToPlatListToggle}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <div class="tel-numbers"><strong>Playlist</strong></div>
                                <MDBAutocomplete data={data} placeholder="Search" onSearch={onSearch} />
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color='secondary' onClick={AddToPlatListToggle}>
                                    {t("close")}
                                </MDBBtn>
                                <MDBBtn>Add</MDBBtn>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>



                <MDBModal tabIndex='-1' open={EditMedia} setOpen={setEditMedia}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{t('editMedia')}</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={EditMediaToggle}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <div class="tel-numbers"><strong>{t("name")}</strong></div>
                                <input className="form-control form-outline" id='form1' type='text' placeholder="Enter a Name" value="Test" />
                                <div class="tel-numbers mt-3"><strong>{t("Description")}</strong></div>
                                <input className="form-control form-outline" id='form1' type='text' placeholder="Enter a Description" value="TEST AA" />
                                <div class="tel-numbers mt-3"><strong>{t("Media")}</strong></div>
                                <audio className="w-100" src="" controls></audio>
                                <div class="tel-numbers mt-3"><strong>{t("Relatedresources")}</strong></div>
                                <div className="editMediaTable">
                                    <MDBDatatable data={Associatedresources} sortField="Resource" />
                                </div>
                                {/* <div className="noResource-link">
                                    <MDBIcon fas icon="link" />
                                    <h4 className="mt-2">No {t("Relatedresources")}</h4>
                                    <p className="text-secondary">{t("Relatedresourcestxt")}</p>
                                </div> */}





                            </MDBModalBody>
                            <MDBModalFooter className="w-100 d-flex justify-content-between">
                                <MDBBtn color="danger" className="float-start">Delete</MDBBtn>
                                <div>
                                    <MDBBtn color='secondary' onClick={EditMediaToggle}>
                                        {t("close")}
                                    </MDBBtn>
                                    <MDBBtn className="ms-3">{t("save")}</MDBBtn>

                                </div>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>



                <MDBModal tabIndex='-1' open={EditMediaupload} setOpen={setEditMediaupload}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{t('editMedia')}</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={EditMediauploadToggle}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <div class="tel-numbers"><strong>Name</strong></div>
                                <input className="form-control form-outline" id='form1' type='text' placeholder="Enter a Name" value="Test" />
                                <div class="tel-numbers mt-3"><strong>Media</strong></div>
                                <audio className="w-100" src="" controls></audio>
                                <div class="tel-numbers mt-3"><strong>Associated resources</strong></div>
                                <div className="editMediaTable">
                                    <MDBDatatable data={AssociatedresourcesUpload} sortField="Resource" />
                                </div>
                            </MDBModalBody>
                            <MDBModalFooter className="w-100 d-flex justify-content-between">
                                <MDBBtn color="danger" className="float-start">{t("Remove")}</MDBBtn>
                                <div>
                                    <MDBBtn color='secondary' onClick={EditMediauploadToggle}>
                                        {t("close")}
                                    </MDBBtn>
                                    <MDBBtn className="ms-3">{t("save")}</MDBBtn>

                                </div>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>



                <MDBModal tabIndex='-1' open={DeleteMusicUpload} setOpen={setDeleteMusicUpload}>
                    <MDBModalDialog centered>
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>{t('deletemusic')} "sirslyhigh"</MDBModalTitle>
                                <MDBBtn className='btn-close' color='none' onClick={DeleteMusicUploadToggle}></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <MDBAlert open
                                    className="alert-center"
                                    // className='w-100' 
                                    color='danger'>
                                    <i class="fas fa-exclamation-triangle fs-4 me-3"></i>1 resource is associated to this music
                                </MDBAlert>
                                <p>{t("DeleteMusictxt")}</p>
                                <div className="editMediaTable">
                                    <MDBDatatable data={AssociatedresourcesUpload} sortField="Resource" />
                                </div>
                            </MDBModalBody>
                            <MDBModalFooter className="w-100 d-flex justify-content-between">
                                <MDBBtn outline className="float-start"><MDBIcon fas icon="redo" className="me-2" />Refresh</MDBBtn>
                                <div>
                                    <MDBBtn color='secondary' onClick={DeleteMusicUploadToggle}>
                                        Cancel
                                    </MDBBtn>
                                    <MDBBtn className="ms-3" color="danger">{t("Remove")}</MDBBtn>

                                </div>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

                {internalError && (<MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={3000}
                    onClose={() => { setInternalError(false); setInternalErrorMessage(''); }}
                >{internalErrorMessage ? internalErrorMessage : "Internal Server Error"}</MDBAlert>)}

                {failedErrorMessage !== "" && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={5000}
                        onClose={() => setFailedErrorMessage("")}
                    >
                        {failedErrorMessage}
                    </MDBAlert>
                )}

                {successMsg !== '' && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="success"
                        autohide
                        position="bottom-right"
                        delay={5000}
                        onClose={() => setSuccessMsg('')}
                    >
                        <i className="fas fa-check-circle me-3"></i>
                        <span className="alert-msg">{successMsg}</span>
                    </MDBAlert>
                )}
                {isDirty && (
                    <SaveChanges
                        onClose={closeSave}
                        isdirtyFields={isDirty}
                        onSave={(e) => {
                            e.preventDefault();
                            handleSubmit(updateDefaultMOHGre)();
                        }}
                    />
                )}
                {/* TTS Generation Popup */}
                <TTSGenerationPopup
                    isOpen={showTTSGeneration}
                    isMediaFalg={true}
                    onClose={() => setShowTTSGeneration(false)}
                    onCancel={() => {
                        setIsGenerating(false);
                        setShowTTSGeneration(false);
                    }}
                    isGenerating={isGenerating}
                />
                <Tooltip anchorSelect=".playToolTip" place="top" className="exampleTooltip">
                    Play
                </Tooltip>
                <Tooltip anchorSelect=".downloadToolTip" place="top" className="exampleTooltip">
                    Download Sound Clip
                </Tooltip>
                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove Sound Clip
                </Tooltip>
                <Tooltip anchorSelect=".editToolTip" place="top" className="exampleTooltip">
                    Edit Sound Clip
                </Tooltip>
                {/* Download Progress Modal */}
                <MDBModal
                    open={showDownloadProgress}
                    staticBackdrop
                    tabIndex='-1'
                    className="download-progress-modal"
                >
                    <MDBModalDialog centered size="sm">
                        <MDBModalContent>
                            <MDBModalBody className="download-progress-body">
                                {/* Circular Progress */}
                                <div className="circular-progress-wrapper">
                                    <svg className="progress-ring" width="140" height="140">
                                        {/* Background Circle */}
                                        <circle
                                            className="progress-ring-bg"
                                            stroke="#e9ecef"
                                            strokeWidth="10"
                                            fill="transparent"
                                            r="54"
                                            cx="70"
                                            cy="70"
                                        />
                                        {/* Progress Circle */}
                                        <circle
                                            className="progress-ring-circle"
                                            stroke="#0d6efd"
                                            strokeWidth="10"
                                            fill="transparent"
                                            r="54"
                                            cx="70"
                                            cy="70"
                                            style={{
                                                strokeDasharray: 2 * Math.PI * 54,
                                                strokeDashoffset: 2 * Math.PI * 54 - (downloadProgress / 100) * (2 * Math.PI * 54),
                                            }}
                                        />
                                    </svg>
                                    {/* Percentage Text */}
                                    <div className="progress-percentage-text">
                                        {Math.round(downloadProgress)}%
                                    </div>
                                </div>

                                {/* Downloading Text */}
                                <h5 className="download-title">Downloading {downloadingFileName}...</h5>

                                {/* Subtitle */}
                                <p className="download-subtitle text-muted">
                                    Please wait, this may take a moment.
                                </p>
                            </MDBModalBody>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>

            </>
        </React.Fragment >
    );
}

export default MediaLanding;
